import MobileNavLink from "@/components/nav/mobile-link";
import MobileMenuShell from "@/components/header/mobile-menu-shell";

type CustomerMobileMenuProps = Readonly<{
  isLoggedIn: boolean;
}>;

export default function CustomerMobileMenu({
  isLoggedIn,
}: CustomerMobileMenuProps) {
  return (
    <MobileMenuShell>
      {(close) => (
        <>
          <MobileNavLink
            href="/advertisements-consultants/advertisements-filter/list"
            onClick={close}
          >
            آگهی‌ها{" "}
          </MobileNavLink>
          <MobileNavLink href="/customer/consultants" onClick={close}>
            مشاوران{" "}
          </MobileNavLink>
          <MobileNavLink href="/articles" onClick={close}>
            وبلاگ
          </MobileNavLink>
          <MobileNavLink href="/customer/about" onClick={close}>
            درباره ما{" "}
          </MobileNavLink>
          <MobileNavLink href="/customer/contact-us" onClick={close}>
            ارتباط با ما{" "}
          </MobileNavLink>
          <MobileNavLink href="/create-ads" onClick={close}>
            ثبت آگهی
          </MobileNavLink>
          {!isLoggedIn && (
            <MobileNavLink href="/login-otp" onClick={close} itemColor="text-brand-700">
              ورود / ثبت نام
            </MobileNavLink>
          )}
        </>
      )}
    </MobileMenuShell>
  );
}
